export default "__VITE_ASSET__C1N8Q5il__"